export function readableQueryError(error: unknown, fallback: string) {
  if (error instanceof Error && error.message.trim()) return error.message;
  if (typeof error === "object" && error && "message" in error && typeof (error as { message?: unknown }).message === "string" && (error as { message: string }).message.trim()) {
    return (error as { message: string }).message;
  }
  return fallback;
}

/** React Query cancellation is normal during route and tab unmounts and must not be shown as a failure. */
export function isBenignQueryCancellation(error: unknown): boolean {
  if (!error || typeof error !== "object") return false;
  const candidate = error as { name?: unknown; message?: unknown; cause?: unknown };
  const name = typeof candidate.name === "string" ? candidate.name.toLowerCase() : "";
  const message = typeof candidate.message === "string" ? candidate.message.toLowerCase() : "";
  if (name === "aborterror" || name === "cancellederror") return true;
  if (/\b(abort|aborted|cancel|cancelled|canceled)\b/.test(message)) return true;
  return candidate.cause !== error && isBenignQueryCancellation(candidate.cause);
}

export function queryFailureLabelKey(queryKey: readonly unknown[]) {
  const key = queryKey.slice(0, 2).filter((part): part is string => typeof part === "string").join(".");
  const labels: Record<string, string> = {
    "ledger.trialBalance": "businessStatements.trialBalance",
    "ledger.generalLedger": "businessStatements.generalLedger",
    "ledger.openingStatus": "ledger.openingTitle",
    "businessStatements.report": "businessStatements.title",
    "businessStatements.exportData": "businessStatements.title",
    "businessStatements.xbrlReview": "xbrl.title",
    "businessStatements.xbrlHistory": "xbrl.title",
  };
  return labels[key] ?? "route.errorTitle";
}

/** The location is captured when the error occurs so route changes cannot misattribute stale feedback. */
export function queryFailureOriginLabelKey(location: string) {
  const path = location.split("?")[0] || "/";
  const labels: Record<string, string> = {
    "/business-statements": "businessStatements.title",
    "/account": "nav.account",
    "/invoices": "invoice.title",
    "/documents": "document.title",
    "/dashboard": "nav.dashboard",
    "/income-statement": "income.title",
    "/transactions": "transactions.title",
    "/budgets": "budgets.title",
    "/analytics": "analytics.title",
    "/sms": "sms.title",
    "/export": "export.title",
  };
  return labels[path] ?? "route.errorTitle";
}
